import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, Optional, Output, ViewChild } from '@angular/core';
import { ref, uploadBytesResumable, getDownloadURL, uploadString } from '@angular/fire/storage';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as fireStorage from '@angular/fire/storage';
import { FirestoreService } from 'src/app/shared/services/firestore.service';
import { UxserviceService } from 'src/app/shared/services/uxservice.service';
@Component({
  selector: 'app-customfileupload',
  templateUrl: './customfileupload.component.html',
  styleUrls: ['./customfileupload.component.scss']
})
export class CustomfileuploadComponent {
  @Input() imagearray: any;
  @Input() from: any;
  @Input() type: any;
  @Input() filetype: any;

  @Output() getuploadedfiletype: EventEmitter<any> = new EventEmitter<any>();

  @Output() getuploadedimage: EventEmitter<any> = new EventEmitter<any>();
  @Output() getthumbnailimg: EventEmitter<any> = new EventEmitter<any>();
  @Output() getloadingstatus: EventEmitter<any> = new EventEmitter<any>();
  @Output() getimagecontent: EventEmitter<any> = new EventEmitter<any>();
  @Output() getimagefetchingStatus: EventEmitter<any> = new EventEmitter<any>();




  pdfthumbnailurl: any
  urlSource: any
  firestoreID: any;
  progress: number = 0;
  plotdetails: any = {};
  isSubmitting: boolean = false;
  _bucketPath: any = 'alignmaster-vduploads';

  issketchadded: boolean = false;
  issketchuploaded: boolean = false;
  isloadingcomplete: boolean = true;
  sketchuploaderror: boolean = false;
  filetypeselected: any = 'image/*';
  imgfiletype: any = 'image/*';
  pdffiletype: any = '.pdf';
  pdfupload: boolean = false;
  imgupload: boolean = true;
  dwgupload: boolean = true;
  ismultiple: boolean = false;
  ischoosefile: boolean = false;
  isOpen = false;
  filelinkarray: any[] = [];
  pdfurl: any = '';

  @ViewChild('fileInput')

  fileInput!: ElementRef;
  docfileInput!: ElementRef;
  fileinput: any;
  maxlimit: boolean = false;
  files: any[] = [];
  isfileuploaderror: boolean = false;
  issketchedited: boolean = false;
  selecttypedisabled: boolean = false
  newplotinfo: any = {}
  analysisResult: any
  isimagedatafetching: boolean = false
  constructor(
    private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    // @Optional() public dialogRef: MatDialogRef<GsquareplotaddComponent>,
    private firestoreService: FirestoreService,
    private uxservice: UxserviceService,
    private storage: fireStorage.Storage,
    public dialog: MatDialog,
    private elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {

    if (this.imagearray) {
      this.filelinkarray = this.imagearray
      if (this.filelinkarray.length == 0) {
        this.issketchuploaded = false
      }
      else {
        this.issketchuploaded = true

      }


    }
    if (this.from == "multiple") {
      this.ismultiple = true
      if (this.type == "image") {
        this.filetypeselected = 'image/*'
        // this.filetype='image/*'
        this.changeDetectorRef.detectChanges()

      }

      if (this.type == "dwg") {
        this.filetypeselected = '.dwg'
        // this.filetype='image/*'
        this.dwgupload = true
        this.changeDetectorRef.detectChanges()
        this.imgupload = false
      }
      if (this.type == "pdf") {
        this.filetypeselected = '.pdf'
        // this.filetype='.pdf'
        this.changeDetectorRef.detectChanges()

      }
    }
    if (this.from == "single") {
      this.ismultiple = false
      if (this.type == "image") {
        this.filetypeselected = 'image/*'
        this.selecttypedisabled = true
        this.dwgupload = false
        this.pdfupload = false

      }

      if (this.type == "dwg") {
        this.filetypeselected = '.dwg'
        // this.filetype='image/*'
        this.dwgupload = true
        this.changeDetectorRef.detectChanges()
        this.imgupload = false
        this.pdfupload = false

      }

      if (this.type == "both") {
        // this.filetypeselected='image/*'
        this.selecttypedisabled = false
      }
      if (this.type == "pdf") {
        this.dwgupload = false
        this.imgupload = false
        this.pdfupload = true
        this.filetypeselected = '.pdf'
        this.selecttypedisabled = true
      }
    }
  }

  ngOnChanges(): void {
    if (this.imagearray) {
      this.filelinkarray = this.imagearray
      if (this.filelinkarray.length == 0) {
        this.issketchuploaded = false
      }
      else {
        this.issketchuploaded = true

      }


    }
    // if(this.from=="multiple"){
    //   this.ismultiple=true
    //   if(this.type=="image"){
    //     this.filetypeselected='image/*'
    //     this.filetype='image/*'
    //     this.changeDetectorRef.detectChanges()

    //   }
    //   if(this.type=="pdf"){
    //     this.filetypeselected='.pdf'
    //     this.filetype='.pdf'
    //     this.changeDetectorRef.detectChanges()

    //   }
    // }
    // if(this.from=="single"){
    //   this.ismultiple=false
    //   if(this.type=="image"){
    //     this.filetypeselected='image/*'
    //     this.selecttypedisabled=true
    //   }

    //   if(this.type=="both"){
    //     // this.filetypeselected='image/*'
    //     this.selecttypedisabled=false
    //   }
    //   if(this.type=="pdf"){
    //     this.filetypeselected='.pdf'
    //     this.selecttypedisabled=true
    //   }
    // }
  }
  ngAfterViewInit() {
    this.fileinput = this.elementRef.nativeElement.querySelector('#fileInput');

  }
  deletesketchupload(eve: any, index: number) {
    if (this.pdfupload) {
      this.pdfurl = '';
    }
    // if(!this.isloadingcomplete){
    //   return;
    // }
    // console.log(index);
    // console.log(this.filelinkarray);
    this.files.splice(index, 1);
    this.filelinkarray.splice(index, 1);
    if (this.files.length == 0) {
      this.issketchuploaded = false;
    }
  }

  editsketchupload(eve: any, index: number) {
    this.issketchedited = true;

    this.changeDetectorRef.detectChanges();
    if (this.pdfupload) {
      this.pdfurl = '';
      this.filelinkarray.splice(index, 1);
      this.changeDetectorRef.detectChanges();
    }
    this.filelinkarray.splice(index, 1);
    this.changeDetectorRef.detectChanges();
    console.log(this.filelinkarray);
    if (this.filelinkarray.length == 0) {
      this.issketchuploaded = false;
    }
  }
  async fileBrowseHandler(files: any) {


    console.log(files, this.files);
    if (files.files[0].type === 'application/pdf') {
      // const imageDataUrl = await this.getPdfFirstPageAsImage(files.files[0]);

      // // Now you can use imageDataUrl as needed (e.g., display it or save it)
      // // console.log(imageDataUrl);
      // if (imageDataUrl) {
      //   this.urlSource = imageDataUrl
      //   console.log(this.urlSource);
      //   files.files[0].url = this.urlSource
      // this.isloadingcomplete = false;
      // this.getloadingstatus.emit( this.isloadingcomplete);
      //   // this.startUploadpdfimage(files.files[0], this.urlSource)

      // }


    }
    //If more than 10  pics added
    if (this.fileinput?.files?.length > 5 || this.files?.length > 5) {
      // Change 5 to your desired maximum number of files
      this.maxlimit = true;
      this.uxservice.showError('You are only allowed to upload a maximum of 5 files');
      this.isloadingcomplete = false;
      this.getloadingstatus.emit(this.isloadingcomplete);

      // this.isloadingcomplete = true;

      this.prepareFilesList(files.files);
      this.issketchuploaded = true;
    } else {
      this.isloadingcomplete = false;
      this.getloadingstatus.emit(this.isloadingcomplete);

      //If 10 pics added at a time
      if (this.filelinkarray.length == 5) {
        this.uxservice.showError('You are only allowed to upload a maximum of 5 files');

        this.isloadingcomplete = true;
        this.getloadingstatus.emit(this.isloadingcomplete);

      } else {

        this.prepareFilesList(files.files);
        this.isloadingcomplete = false;
        this.getloadingstatus.emit(this.isloadingcomplete);

        this.issketchuploaded = true;
      }
    }
  }
  async readFile(index: any, item: any) {
    console.log(index);
    console.log(item);

    if (this.filelinkarray.length <= 4) {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent) => {
        item[index].url = (<FileReader>e.target).result;
      };




      await reader.readAsDataURL(item[index]);

      if (item) {
        this.files.push(item[index]);
        console.log(this.files);
        //  return;
        this.startUpload(index, item, item[index]);
      }
    } else {
      this.isloadingcomplete = true;
      this.getloadingstatus.emit(this.isloadingcomplete);

    }
  }

  arrayListLoop(index: any, array: any) {
    if (index == 4) {
      this.isloadingcomplete = true;
      this.getloadingstatus.emit(this.isloadingcomplete);

      this.fileinput.value = '';
      //Our loop over--> gotoAnotherFunction
    } else if (index == array.length - 1) {
      this.isloadingcomplete = true;
      this.getloadingstatus.emit(this.isloadingcomplete);

      this.fileinput.value = '';

      console.log(this.fileInput);

      //Our loop over--> gotoAnotherFunction
      // this.fileInput.nativeElement.value = '';
    } else if (index == 5) {
      this.isloadingcomplete = true;
      this.getloadingstatus.emit(this.isloadingcomplete);

      this.fileinput.value = '';

      this.maxlimit = true;
      return;
      //Our loop over--> gotoAnotherFunction
    } else {
      // Loop not yet completed
      index++;
      console.log(index, array, this.filelinkarray);
      // again read next file
      this.readFile(index, array);
    }
  }

  async prepareFilesList(files: Array<any>) {
    console.log(files);

    // Now you can use imageDataUrl as needed (e.g., display it or save it)
    // console.log(imageDataUrl);

    this.isfileuploaderror = false;
    this.ischoosefile = true;

    this.readFile(0, files);
  }
  geturldata(url: string) {
    //  To get stored doc name form firebase storage
    const storageRef = ref(this.storage, url);
    // console.log(storageRef.name);
    const filename = storageRef.name.split('_')[1];
    // console.log(filename);
    return filename;
  }
  getfiletype(type: string) {
    // To get  doc type in specific pattern

    const filename = type.split('/')[1].toUpperCase();
    console.log(filename);
    return filename;
  }

  getType() {
    if (this.type == "image") {
      this.filetypeselected = 'image/*'
      // this.filetype='image/*'

    }
    if (this.type == "pdf") {
      this.filetypeselected = '.pdf'
      // this.filetype='.pdf'

    }
  }
  async startUpload(index: number, arr: any, item: any) {
    this.progress = 0;
    console.log(this.files);

    let currentFile = item;
    const basePath = `${this._bucketPath
      }/${new Date().getFullYear()}/${Date.now()}_${currentFile.name}`;
    const storageRef = ref(this.storage, basePath);
    const uploadTask = uploadBytesResumable(storageRef, currentFile);
    uploadTask
      .then(async () => {
        await getDownloadURL(storageRef).then((url) => {


          this.issketchedited = true;

          if (this.imgupload) {
            console.log("imgupload");

            this.filelinkarray.push(url);
            console.log(url);
            // this.isimagedatafetching=true
            // this.getimagefetchingStatus.emit(this.isimagedatafetching)

            // this.openAiService.analyzeFloorPlan(url).subscribe((result) => {
            //   this.analysisResult = result;
            //   console.log(this.analysisResult);

            //   this.isimagedatafetching=false;
            //   this.getimagefetchingStatus.emit(this.isimagedatafetching)
            //   const cleanedResponse = this.analysisResult
            //   .replace(/```json|```/g, '')
            //   .trim();
            //   console.log(cleanedResponse);
            //   const datajson = JSON.parse(cleanedResponse);
            //   console.log(datajson);

            // this.getimagecontent.emit(datajson)
            // });
            console.log(this.filelinkarray);
          }

          if (this.dwgupload) {

            if (this.imgupload) {
              return
            }
            console.log("dwgupload");

            this.filelinkarray.push(url);
            console.log(url);
            // this.isimagedatafetching=true
            // this.getimagefetchingStatus.emit(this.isimagedatafetching)

            // this.openAiService.analyzeFloorPlan(url).subscribe((result) => {
            //   this.analysisResult = result;
            //   console.log(this.analysisResult);

            //   this.isimagedatafetching=false;
            //   this.getimagefetchingStatus.emit(this.isimagedatafetching)
            //   const cleanedResponse = this.analysisResult
            //   .replace(/```json|```/g, '')
            //   .trim();
            //   console.log(cleanedResponse);
            //   const datajson = JSON.parse(cleanedResponse);
            //   console.log(datajson);

            // this.getimagecontent.emit(datajson)
            // });
            console.log(this.filelinkarray);
          }

          if (this.pdfupload) {
            console.log("pdfff");

            this.pdfurl = url;
            this.filelinkarray.push(url);

            console.log(this.pdfupload);

            console.log(this.pdfurl);
            console.log(this.filelinkarray);

          }
          if (this.filelinkarray?.length <= 5) {
            this.maxlimit = false;
          }
          if (this.filelinkarray?.length > 5) {
            // this.filelinkarray.push(url);
            console.log(this.filelinkarray);

            this.maxlimit = true;
          }
          this.getuploadedimage.emit(this.filelinkarray);
          this.getuploadedfiletype.emit(this.filetype)
        });
      })
      .then(() => {
        // this.isloadingcomplete = true;
        // Loop each element in list

        this.arrayListLoop(index, arr);
      });
  }

  onSelectingfiletype(event: any) {
    console.log(event.value);


    if (event.value == 'PDF') {
      console.log('ppppppppppppp');
      this.filetype = '.pdf';
      this.pdfupload = true;
      this.dwgupload = false;
      this.imgupload = false;
      this.ismultiple = false;
    } else {
      console.log('iiiiiiiiiiii');
      this.pdfupload = false;
      this.imgupload = true;
      this.ismultiple = true;

      this.filetype = 'image/*';
    }
  }



  readFileAsArrayBuffer(file: File): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const arrayBuffer = event.target.result as ArrayBuffer;
        resolve(arrayBuffer);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsArrayBuffer(file);
    });
  }


  async startUploadpdfimage(files: any, urlsrc: any) {

    let currentFile = files;
    const basePath = `${this._bucketPath
      }/${new Date().getFullYear()}/${Date.now()}_${'brochureimg'}`;
    const storageRef = ref(this.storage, basePath);
    const uploadTask = uploadString(storageRef, urlsrc, 'data_url');
    // const uploadTask = uploadBytesResumable(storageRef, currentFile);
    uploadTask.then(async () => {
      await getDownloadURL(storageRef).then((url) => {
        this.isloadingcomplete = true;
        this.getloadingstatus.emit(this.isloadingcomplete);

        // if (this.data.fromwhere === "sitevisit") {
        //   this.filelinkarray.push(url)
        // } else {
        this.pdfthumbnailurl = url
        this.getthumbnailimg.emit(this.pdfthumbnailurl);

      })
    })
  }
}
